// extracted by mini-css-extract-plugin
export default {"events-timeout":"styles_events-timeout__ej4e-"};